import React, { useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import { feedback } from '../../../services/api/apiManager';

import CloseIcon from '@mui/icons-material/Close';

import StarIcon from '@mui/icons-material/Star';

import {
	Alert,
	Box,
	CssBaseline,
	Grid,
	IconButton,
	Rating,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';

import { Link } from 'react-router-dom';

import Paper from '@mui/material/Paper';

import Button from '@mui/material/Button';

import PropTypes from 'prop-types';

const FeedbackPopup = ({ onClose }) => {
	const defaultTheme = createTheme();
	const [value, setValue] = useState('');
	const [feedbackText, setFeedbackText] = useState('');

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [error401Snackbar, setError401Snackbar] = useState(false);
	const [openEmptyFieldSnackbar, setOpenEmptyFieldSnackbar] = useState(false);

	const handleSubmit = async () => {
		try {
			debugger;

			if (!value) {
				setOpenEmptyFieldSnackbar(true); // Show Snackbar for empty fields
				return;
			}

			const response = await feedback({
				Uid: 2147483647,
				Rating: value,
				Feedback: feedbackText,
			});
			// Optionally, you can add code here to handle the response if needed.
			setFeedbackText('');

			if (response?.status === 200) {
				setOpenSnackbar(true);
				setTimeout(() => {
					onClose(); // Assuming `onclose` is a function to close the snackbar
				}, 1500);
			} else if (response?.status === 401) {
				setError401Snackbar(true);
			} else {
				// setError401Snackbar(true);
			}
		} catch (error) {
			// Optionally, you can add code here to handle errors if needed.
			// setError401Snackbar(true);
		}
	};
	const handleSnackbarClose = () => {
		setOpenSnackbar(false);
		setError401Snackbar(false);
		setOpenEmptyFieldSnackbar(false);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				item
				justifyContent="center"
				alignItems={'center'}
				sx={{ paddingTop: '30px' }}
			>
				<Grid
					component={Paper}
					square
					item
					xs={10}
					sm={9}
					md={6}
					lg={4.5}
					xl={4}
					sx={{
						backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
						backgroundRepeat: 'no-repeat',
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						borderRadius: '15px',
						// height:'75vh',
					}}
				>
					<Box
						sx={{
							padding: '15px 30px',
							display: 'flex',
							flexDirection: 'column',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								padding: '10px',
							},
						}}
					>
						<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{
									maxWidth: '200px',
									height: 'auto',
									objectFit: 'contain',
								}}
							/>
							<IconButton
								aria-label="close"
								onClick={onClose}
								sx={{ color: '#ED2828' }}
							>
								<CloseIcon />
							</IconButton>
						</Box>
						<Typography
							component="h1"
							variant="h5"
							sx={{
								alignSelf: 'start',
								fontSize: '25px',
								fontWeight: '600',
								mt: '10px',
							}}
						>
							Feedback
						</Typography>
						<Box component="form" noValidate sx={{}}>
							<Grid
								container
								spacing={2}
								justifyContent="center"
								alignItems="center"
							>
								<Grid item textAlign="center" sx={{ margin: '20px' }}>
									<Typography
										variant="body1"
										sx={{
											color: '#6F6A6A',
											textAlign: 'center',
											fontFamily: 'Poppins',
											fontSize: '18px',
											fontStyle: 'normal',
											fontWeight: '400',
											lineHeight: 'normal',
										}}
									>
										How much are you satisfied ?
									</Typography>
									<Rating
										name="simple-controlled"
										value={value}
										icon={
											<StarIcon style={{ color: '#FFDC79', margin: '8px' }} />
										}
										emptyIcon={
											<StarIcon style={{ border: 'none', margin: '8px' }} />
										}
										onChange={(event, newValue) => {
											setValue(newValue);
										}}
										sx={{
											borderRadius: '9px 9px 9px 0px',
											background: ' #4BA5EF',
											padding: '5px 25px',
											marginTop: '5px',
											marginBottom: '5px',
											'& .MuiSvgIcon-root': {
												fontSize: '20px',
											},
										}}
									/>
								</Grid>
							</Grid>
							<Typography
								variant="body2"
								sx={{ color: '#7E7D7D', fontSize: '15px' }}
							>
								Any Suggestions?
							</Typography>
							<TextField
								multiline
								fullWidth
								value={feedbackText}
								onChange={(e) => setFeedbackText(e.target.value)}
								rows={3}
								variant="outlined"
								sx={{
									borderRadius: '6px',
									border: '1.5px solid #DDE6F1',
									marginBottom: '20px',
									boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
								}}
							/>
							<Button
								variant="contained"
								onClick={() => handleSubmit()}
								fullWidth
								size="small"
								sx={{
									background: ' #e87511',
									borderRadius: '6px',
									// height: '50px',
									// marginTop: '100px',
									fontFamily: 'Poppins',
									fontSize: '18px',
									fontWeight: '400',
									marginTop: '20px',
									'&:hover': {
										background: '#e87511',
									},
								}}
							>
								SUBMIT
							</Button>

							{/* snack bar */}

							<Snackbar
								open={openSnackbar}
								autoHideDuration={1500} // Adjust the duration as needed
								onClose={handleSnackbarClose}
								anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
							>
								<Alert onClose={handleSnackbarClose} severity="success">
									Feedback Recorded successfully.
								</Alert>
							</Snackbar>
							{/* error 401 snackbar */}
							<Snackbar
								open={error401Snackbar}
								autoHideDuration={1500}
								onClose={handleSnackbarClose}
								anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
							>
								<Alert
									onClose={handleSnackbarClose}
									severity="error"
									sx={{
										width: '100%',
										background: 'red',
										color: 'white',
										fontFamily: 'Poppins',
										'& .MuiAlert-icon': {
											color: 'white', // Change icon color to white
										},
									}}
								>
									Error 401
								</Alert>
							</Snackbar>
							<Snackbar
								open={openEmptyFieldSnackbar}
								autoHideDuration={1000}
								onClose={handleSnackbarClose}
								anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
							>
								<Alert
									onClose={handleSnackbarClose}
									severity="error"
									sx={{
										width: '100%',
										background: 'red',
										color: 'white',
										fontFamily: 'Poppins',
										'& .MuiAlert-icon': {
											color: 'white', // Change icon color to white
										},
									}}
								>
									Fill All the Fields
								</Alert>
							</Snackbar>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
};

FeedbackPopup.propTypes = {
	onClose: PropTypes.func.isRequired, // onClose should be a function and required
};

export default FeedbackPopup;
